import imageCompression from 'browser-image-compression'

const toNamedFile = (blob, name, type) => new File([blob], name, { type: type || blob.type })

export async function compressCoverImage(file, { maxSizeMB = 1, maxWidthOrHeight = 1400 } = {}) {
  if (file && file.type === 'image/gif') {
    return file
  }
  let input = file
  if (file && (file.type === 'image/heic' || file.type === 'image/heif')) {
    // heic2any is 1.3 MB; only fetch it for the rare HEIC upload.
    const { default: heic2any } = await import(/* webpackChunkName: "heic2any" */ 'heic2any')
    const converted = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.8 })
    input = toNamedFile(converted, (file.name || 'cover').replace(/\.[^.]+$/, '') + '.jpg', 'image/jpeg')
  }
  const opts = { maxSizeMB, maxWidthOrHeight, useWebWorker: true }
  if (input && input.type === 'image/png') {
    opts.fileType = 'image/webp'
  }
  const compressed = await imageCompression(input, opts)
  let outName = input.name
  if (opts.fileType === 'image/webp' && !/\.webp$/i.test(outName)) {
    outName = outName.replace(/\.[^.]+$/, '') + '.webp'
  }
  return toNamedFile(compressed, outName, opts.fileType || compressed.type)
}
